import request from '@/api/request'
import {
  GetTiktokShopCallbackRes,
  GetTiktokShopInfoRes,
  GetTiktokShopsWarehouseReq,
  GetTiktokShopsWarehouseRes,
  GetTiktokShopUrlRes,
  PublishShopsProductReq,
  PublishShopsProductRes,
  Res,
  UploadShopsImagesRes
} from '@/types/api'

// 获取一键上架授权链接
export const getTiktokShopUrl = async () => {
  return request.get<Res<GetTiktokShopUrlRes>>(`/auth/shops/tiktok/redirect`)
}

// 店铺授权回调
export const getTiktokShopCallback = async ({ code }: { code: string }) => {
  return request.get<Res<GetTiktokShopCallbackRes>>(`/auth/shops/tiktok/callback`, { params: { code } })
}

export const getTiktokShopInfo = async () => {
  return request.get<Res<GetTiktokShopInfoRes>>(`/users/shops/tiktok`)
}

export const getShopsWarehouse = () => {
  return request.get<Res<GetTiktokShopsWarehouseRes>>(`/users/shops/warehouse`)
}

export const uploadShopsImages = (data: { product_id: string }) => {
  return request.post<Res<UploadShopsImagesRes>>(`/tools/shops/upload-images`, data)
}

export const publishShopsProduct = (data: PublishShopsProductReq) => {
  return request.post<Res<PublishShopsProductRes>>(`/tools/shops/publish`, data)
}
